function Category({ title }) {
  return (
    <div className="rounded-2xl border py-2 px-4 cursor-pointer text-gray-500 font-light">
      {title}
    </div>
  );
}

export default Category;
